import { render, staticRenderFns } from "./ApiSmsSend.vue?vue&type=template&id=764305a4&scoped=true"
import script from "./ApiSmsSend.vue?vue&type=script&lang=js"
export * from "./ApiSmsSend.vue?vue&type=script&lang=js"
import style0 from "./ApiSmsSend.vue?vue&type=style&index=0&id=764305a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764305a4",
  null
  
)

export default component.exports